/** @format */

import { useContext, useEffect, useState } from 'react';

import Marquee from 'react-easy-marquee';
import { Link } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Master from '../Layouts/Master';

const Home = () => {
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true);
      await useApi.get(
        '/category?no-paginate=true',
        {},
        (res) => {
          eventContext.categories = res.data.data;
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
      await useApi.get(
        '/event/important',
        {},
        (res) => {
          eventContext.eventsImportant = res.data.data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
    };
    getCategories();
  }, []);
  return loading ? (
    <Loading />
  ) : (
    <Master showSidebar={false} containerFullWidth={true} headerFixed={true}>
      <div className='image-cover' style={{ overflow: 'hidden' }}>
        <div className='home-back-img w-100 d-flex flex-column h-100 w-100'>
          {eventContext.eventsImportant?.length > 0 && (
            <div className='row shadow-sm border rounded-1 bg-white m-3'>
              <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 mx-0 px-0'>
                <div className='d-flex flex-row bg-purple p-2 rounded-1'>
                  <span className='text-white f-13 font-weight-bold'>
                    رویداد های مهم :
                  </span>
                </div>
              </div>
              <div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 px-0 mx-0'>
                <div className='w-100 mx-2 f-13 font-weight-bold'>
                  <div className='w-100 p-0 m-0 d-flex flex-row p-2'>
                    <Marquee
                      duration={30000}
                      height='20px'
                      align='start'
                      reverse={true}
                      pauseOnHover={true}
                    >
                      {eventContext.eventsImportant?.map((item, index) => (
                        <div key={item?.id ?? index} className='d-flex flex-row'>
                          <Link
                            to={`/event/show/${item.id}`}
                            className='text-dark mx-5'
                          >
                            {item.title}
                          </Link>
                        </div>
                      ))}
                    </Marquee>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className='row my-3 overflow-hidden'>
            <div className='col-12'>
              <div className='bg-white rounded p-3 shadow mx-5'>
                <p className='text-justify f-14'>
                  این وب سایت جهت ثبت نام در رویدادها و مسابقات و المپیاد ها در
                  رشته های ورزشی {eventContext?.setting?.name ?? ''} میباشد.
                </p>
                <p className='text-justify f-14'>
جهت ثبت نام در مسابقه ابتدا به گزینه ثبت نام در بالای صفحه مراجعه و سپس فرم ثبت نام را پر کنید و پس از ثبت نام به قسمت ورود بالای صفحه بروید و با اطلاعاتی که هنگام ثبت نام وارد می کنید، وارد سایت شوید و پس از آن به قسمت مسابقه مورد نظر بروید و ثبت نام را انجام دهید.
                </p>
              </div>
            </div>
          </div>
          <div className='row overflow-hidden px-0 mx-0'>
            {eventContext.categories.map((item) => (
              <div
                className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mx-0 px-0'
                key={item.id}
              >
                <Link
                  to={`/event/${item.slug}`}
                  className='rounded-circle bg-info d-flex  flex-row justify-content-center align-content-center align-items-center mx-auto my-5 p-1'
                  style={{
                    width: '250px',
                    height: '250px',
                    lineHeight: '36px',
                  }}
                >
                  <span className='text-dark-mode f-20 font-weight-bold'>
                    {item.title}
                  </span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Master>
  );
};

export default Home;
